import { useCallback, useEffect, useState } from "react";
import { CircleDollarSign, CreditCard, ShieldCheck, Wallet } from "lucide-react";
import { Periods, Stat, StatusPill } from "../components/common";
import { QrisCheckout } from "./QrisCheckout";
import { api, idr, signedUsd, usd } from "../lib/api";

export default function Sharing() {
  const [data, setData] = useState(null);
  const [period, setPeriod] = useState("monthly");
  const [paying, setPaying] = useState(null);
  const [sent, setSent] = useState(false);
  const load = useCallback(() => api.get("/sharing").then((r) => setData(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const rows = data?.periods?.[period] || [];
  const monthly = period === "monthly";

  return (
    <>
      <div className="page-intro">
        <div><p className="eyebrow">REVENUE SHARE · 20%</p><h2>Profit sharing</h2><p className="muted">Dihitung otomatis 20% dari profit bersih. Tagihan dibayar per bulan via QRIS.</p></div>
      </div>
      <div className="stats-grid three">
        <Stat testId="sharing-due" label="Belum dibayar" value={usd(data?.due)} hint={`≈ ${idr((data?.due || 0) * (data?.usd_idr_rate || 0))}`} icon={CircleDollarSign} />
        <Stat testId="sharing-paid" label="Total dibayarkan" value={usd(data?.total_paid)} hint="Terverifikasi admin" icon={Wallet} />
        <Stat testId="sharing-rate" label="Sharing rate" value={`${data?.rate || 20}%`} hint={`Kurs ${idr(data?.usd_idr_rate)} / USD`} icon={ShieldCheck} />
      </div>
      {sent && <div className="notice" data-testid="sharing-sent-message"><ShieldCheck size={19} /> Bukti pembayaran sharing terkirim, menunggu verifikasi admin.</div>}
      <section className="panel table-panel">
        <div className="panel-head"><h3>Perhitungan sharing</h3><Periods value={period} onChange={setPeriod} prefix="sharing-period" /></div>
        <div className="table-row table-head"><span>PERIODE</span><span>PROFIT BERSIH</span><span>SHARE (20%)</span><span>{monthly ? "STATUS" : "ESTIMASI IDR"}</span></div>
        {rows.map((r) => (
          <div className="table-row" key={r.name} data-testid={`sharing-row-${r.name}`}>
            <span>{r.name}</span>
            <span className={r.profit >= 0 ? "up" : "down"}>{signedUsd(r.profit)}</span>
            <span>{usd(r.share)}</span>
            {monthly ? (
              <span className="row-end">
                <StatusPill status={r.status} />
                {r.status === "due" && <button className="primary sm" onClick={() => setPaying(r)} data-testid={`pay-sharing-${r.name}`}><CreditCard size={13} /> Bayar</button>}
              </span>
            ) : <span>{idr(r.share * (data?.usd_idr_rate || 0))}</span>}
          </div>
        ))}
      </section>
      {paying && (
        <QrisCheckout title={`Profit sharing ${paying.name}`} subtitle={`20% dari profit ${signedUsd(paying.profit)} (${usd(paying.share)})`} amount={paying.share_idr}
          fields={{ kind: "profit_sharing", period: paying.name }} onClose={() => setPaying(null)} onDone={() => { setPaying(null); setSent(true); load(); }} />
      )}
    </>
  );
}
